import { VISITS_FILTER } from '@app/constants';
import {
  CHF_DATE_END,
  CHF_DATE_START,
  CHF_VISITS_FILTER,
} from '@app/pages/Clients/ClientsList/constants/filterKeysAndIds';

import {
  calculateSelectedFiltersByClients,
  handleSecondClientObjectIndex,
} from '@pages/Clients/ClientsList/utils';

import type { NClientsList } from '@pages/Clients/ClientsList/ClientsList.types';

export const calculateServerFilters: NClientsList.CalculateServerFilters = ({
  serverFilters,
  filterGroupKey,
  groupIndex,
}) => {
  let serverFiltersCount = 0;
  const areFiltersByVisits = filterGroupKey === VISITS_FILTER;

  if (areFiltersByVisits) {
    const values = serverFilters?.[filterGroupKey]?.[groupIndex]?.Values?.[0];

    if (values) {
      const entriesFromValues = Object.entries(values);

      for (const [filterItemKey, value] of entriesFromValues) {
        const isPeriodEndDate =
          filterGroupKey === CHF_VISITS_FILTER &&
          filterItemKey === CHF_DATE_END &&
          values[CHF_DATE_START] !== null &&
          value !== null;

        if (isPeriodEndDate) {
          serverFiltersCount += 0;
        } else {
          if (value !== null) serverFiltersCount += 1;
        }
      }
    }
  } else {
    const includedFiltersIndex = handleSecondClientObjectIndex(groupIndex);
    const excludedFiltersIndex = includedFiltersIndex - 1;

    const values = [
      serverFilters?.[filterGroupKey]?.[excludedFiltersIndex]?.Values?.[0],
      serverFilters?.[filterGroupKey]?.[includedFiltersIndex]?.Values?.[0],
    ];

    serverFiltersCount = calculateSelectedFiltersByClients(values);
  }

  const serverFiltersCountWithLabel =
    ' ' +
    `(${serverFiltersCount}${
      defineLabelPart(serverFiltersCount) ? ' ' : ''
    }${defineLabelPart(serverFiltersCount)})`;

  return serverFiltersCount > 0 ? serverFiltersCountWithLabel : '';
};

function defineLabelPart(serverFiltersCount: number) {
  switch (serverFiltersCount) {
    case 1:
      return 'фильтр';
    case 2:
    case 3:
    case 4:
      return 'фильтра';
    case 5:
    case 6:
    case 7:
    case 8:
    case 9:
    case 10:
      return 'фильтров';
    default:
      return '';
  }
}
